var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgUserUpload = function SvgUserUpload(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.274 0H1.726C.774 0 0 .769 0 1.713v1.85c0 .469.17.922.481 1.277l.817.933a.665.665 0 0 0 .938.065.657.657 0 0 0 .066-.931l-.817-.933a.63.63 0 0 1-.155-.412V1.713c0-.216.178-.393.396-.393h9.548c.219 0 .396.177.396.393v1.85a.63.63 0 0 1-.155.41l-.817.934a.657.657 0 0 0 .066.931c.277.24.697.21.938-.065l.817-.933c.31-.355.481-.808.481-1.278V1.713C13 .77 12.226 0 11.274 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.937 4.197a.582.582 0 0 0-.874 0L3.181 7.34a.717.717 0 0 0 0 .953.582.582 0 0 0 .874 0l1.827-1.993v6.027c0 .372.277.674.618.674s.618-.302.618-.674V6.3l1.827 1.993c.12.131.28.197.437.197a.6.6 0 0 0 .437-.197.717.717 0 0 0 0-.953z"
  })));
};
export default SvgUserUpload;